/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all accounts */
        get: operations["ListAccounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/accounts/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve an account by ID */
        get: operations["GetAccount"];
        /** Update an account by ID */
        put: operations["UpdateAccount"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charges": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all charges */
        get: operations["ListCharges"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charges/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a charge */
        get: operations["GetCharge"];
        /** Update a charge */
        put: operations["UpdateCharge"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all customers */
        get: operations["ListCustomers"];
        put?: never;
        /**
         * Create or reuse a customer
         * @description Creates a registered customer, or returns the existing customer when
         *     `email` or `phone` already belongs to one in the organization.
         *     When `email` is sent, reuse is by email only; a phone match is not used
         *     as a fallback, so a mistyped email cannot attach to another customer.
         *     Reuse does not update the existing record; use PUT to change it.
         *     Returns 200 for reuse and 201 for create.
         */
        post: operations["CreateCustomer"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/customers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a customer by ID */
        get: operations["GetCustomer"];
        /** Update a customer by ID */
        put: operations["UpdateCustomer"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/dunning_configuration": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve the current organization's dunning configuration */
        get: operations["GetDunningConfiguration"];
        put?: never;
        /** Create the current organization's dunning configuration */
        post: operations["CreateDunningConfiguration"];
        delete?: never;
        options?: never;
        head?: never;
        /** Update the current organization's dunning configuration */
        patch: operations["UpdateDunningConfiguration"];
        trace?: never;
    };
    "/external_accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all external accounts
         * @description Lists organization-scoped external accounts. X-Account-Id is ignored if sent.
         */
        get: operations["ListExternalAccounts"];
        put?: never;
        /**
         * Create an external account
         * @description Creates an organization-scoped external account. X-Account-Id is ignored if sent.
         */
        post: operations["CreateExternalAccount"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/external_accounts/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Retrieve an external account by ID
         * @description Retrieves an organization-scoped external account. X-Account-Id is ignored if sent.
         */
        get: operations["GetExternalAccount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/file_uploads": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a file upload */
        post: operations["CreateFileUpload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/file_uploads/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a file upload by ID */
        get: operations["GetFileUpload"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/file_uploads/{id}/complete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Complete a file upload */
        post: operations["CompleteFileUpload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_application_documents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all legal entity application documents */
        get: operations["ListLegalEntityApplicationDocuments"];
        put?: never;
        /** Create a legal entity application document */
        post: operations["CreateLegalEntityApplicationDocument"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all legal entities */
        get: operations["ListLegalEntities"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entities/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a legal entity by ID */
        get: operations["GetLegalEntity"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_applications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a legal entity application */
        post: operations["CreateLegalEntityApplication"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_applications/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a legal entity application by ID */
        get: operations["GetLegalEntityApplication"];
        /** Update a pending legal entity application */
        put: operations["UpdateLegalEntityApplication"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_applications/{id}/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Submit a legal entity application */
        post: operations["SubmitLegalEntityApplication"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_applications/{id}/approve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Approve a legal entity application */
        post: operations["ApproveLegalEntityApplication"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_application_principals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a legal entity application principal */
        post: operations["CreateLegalEntityApplicationPrincipal"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_application_principals/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a legal entity application principal by ID */
        get: operations["GetLegalEntityApplicationPrincipal"];
        /** Update a legal entity application principal */
        put: operations["UpdateLegalEntityApplicationPrincipal"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_principals": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all legal entity principals */
        get: operations["ListLegalEntityPrincipals"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/legal_entity_principals/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a legal entity principal by ID */
        get: operations["GetLegalEntityPrincipal"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchant_applications": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a merchant application */
        post: operations["CreateMerchantApplication"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchant_applications/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a merchant application by ID */
        get: operations["GetMerchantApplication"];
        /** Update a pending merchant application */
        put: operations["UpdateMerchantApplication"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all merchants */
        get: operations["ListMerchants"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a merchant by ID */
        get: operations["GetMerchant"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update a merchant by ID */
        patch: operations["UpdateMerchant"];
        trace?: never;
    };
    "/organization": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve the current organization */
        get: operations["GetOrganization"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update the current organization */
        patch: operations["UpdateOrganization"];
        trace?: never;
    };
    "/origins": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all origins */
        get: operations["ListOrigins"];
        put?: never;
        /** Create a new origin */
        post: operations["CreateOrigin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/origins/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete an origin by ID
         * @description Unregisters the origin host with Apple Pay when it is registered, then deletes the origin. Returns 409 if a render template still uses it. Does not delete the origin if Apple Pay unregistration fails.
         */
        delete: operations["DeleteOrigin"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/embed/payment_intents/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a payment intent by ID */
        get: operations["GetEmbedPaymentIntent"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/embed/payment_intents/{id}/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm a payment intent and wait for processor authorization or sale
         * @description Confirms the payment intent and blocks until the processor approves or declines the authorization or sale. Returns 200 with the post-processor state (for example succeeded, requires_payment_method, or requires_capture). Capture for automatic_async intents may still complete asynchronously after authorization.
         */
        post: operations["ConfirmEmbedPaymentIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_intents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List payment intents */
        get: operations["ListPaymentIntents"];
        put?: never;
        /** Create a new payment intent */
        post: operations["CreatePaymentIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_links": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List payment links */
        get: operations["ListPaymentLinks"];
        put?: never;
        /** Create a new payment link */
        post: operations["CreatePaymentLink"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_links/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a payment link by ID */
        get: operations["GetPaymentLink"];
        /** Update a payment link by ID */
        put: operations["UpdatePaymentLink"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_intents/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a payment intent by ID */
        get: operations["GetPaymentIntent"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_intents/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Cancel a payment intent */
        post: operations["CancelPaymentIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_intents/{id}/capture": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Capture a payment intent */
        post: operations["CapturePaymentIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_methods": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List all payment methods
         * @description Filter by exactly one of customer_id or payment_intent_id.
         */
        get: operations["ListPaymentMethods"];
        put?: never;
        /** Create a payment method */
        post: operations["CreatePaymentMethod"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payment_methods/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a payment method */
        get: operations["GetPaymentMethod"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payouts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all payouts */
        get: operations["ListPayouts"];
        put?: never;
        /** Create a payout */
        post: operations["CreatePayout"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payouts/bulk_create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Bulk create payouts */
        post: operations["BulkCreatePayouts"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payouts/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a payout by ID */
        get: operations["GetPayout"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/processor_transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all processor transactions */
        get: operations["ListProcessorTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/products": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all products */
        get: operations["ListProducts"];
        put?: never;
        /** Create a new product */
        post: operations["CreateProduct"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/products/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Update a product by ID */
        put: operations["UpdateProduct"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/refunds": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all refunds */
        get: operations["ListRefunds"];
        put?: never;
        /** Create a refund */
        post: operations["CreateRefund"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/refunds/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a refund by ID */
        get: operations["GetRefund"];
        /** Update a refund */
        put: operations["UpdateRefund"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/refunds/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Cancel a refund */
        post: operations["CancelRefund"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/render_templates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all render templates */
        get: operations["ListRenderTemplates"];
        put?: never;
        /** Create a new render template */
        post: operations["CreateRenderTemplate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/render_templates/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a render template by ID */
        get: operations["GetRenderTemplate"];
        /**
         * Update a render template by ID
         * @description Replaces the template's origin allowlist. Currency, allowed payment methods, and billing address options cannot be changed.
         */
        put: operations["UpdateRenderTemplate"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/render_templates/{id}/token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a render token for render template */
        post: operations["CreateRenderToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/embed/setup_intents/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a setup intent by ID */
        get: operations["GetSetupIntent"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/embed/setup_intents/{id}/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm a setup intent and wait for card verification
         * @description Confirms the setup intent and, for cards, blocks until processor verification completes. Returns 200 with the post-verification state (for example succeeded, requires_payment_method, or requires_review). Bank account setups succeed without a processor authorization.
         */
        post: operations["ConfirmEmbedSetupIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/setup_intents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create a new setup intent
         * @description Creates an organization-scoped setup intent. X-Account-Id is ignored if sent. The customer must belong to the authenticated organization. Returns an embed token whose JWT payload includes organization_id and setup_intent_id.
         */
        post: operations["CreateSetupIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/subscription_plans": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all subscription plans */
        get: operations["ListSubscriptionPlans"];
        put?: never;
        /** Create a new subscription plan */
        post: operations["CreateSubscriptionPlan"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/subscription_plans/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a subscription plan by ID */
        get: operations["GetSubscriptionPlan"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/subscriptions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all subscriptions */
        get: operations["ListSubscriptions"];
        put?: never;
        /** Create a new subscription */
        post: operations["CreateSubscription"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/subscriptions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a subscription by ID */
        get: operations["GetSubscription"];
        /** Update a subscription by ID */
        put: operations["UpdateSubscription"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/subscriptions/{id}/skip": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Skip subscription billing periods by ID */
        put: operations["SkipSubscription"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/subscriptions/{id}/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Cancel a subscription by ID */
        put: operations["CancelSubscription"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/voids": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all voids */
        get: operations["ListVoids"];
        put?: never;
        /** Create a void */
        post: operations["CreateVoid"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/voids/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a void by ID */
        get: operations["GetVoid"];
        /** Update a void */
        put: operations["UpdateVoid"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/webhook_attempts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all webhook attempts */
        get: operations["ListWebhookAttempts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/webhook_endpoints": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all webhook endpoints */
        get: operations["ListWebhookEndpoints"];
        put?: never;
        /** Create a webhook endpoint */
        post: operations["CreateWebhookEndpoint"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/webhook_endpoints/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieve a webhook endpoint by ID */
        get: operations["GetWebhookEndpoint"];
        /** Update a webhook endpoint by ID */
        put: operations["UpdateWebhookEndpoint"];
        post?: never;
        /** Delete a webhook endpoint by ID */
        delete: operations["DeleteWebhookEndpoint"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/webhook_requests": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all webhook requests */
        get: operations["ListWebhookRequests"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/webhook_requests/{id}/resend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Resend webhook request by ID */
        post: operations["ResendWebhookRequest"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/webhook_requests/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get webhook request by ID */
        get: operations["RetrieveWebhookRequest"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        Meta: {
            current_page?: number;
            prev_page?: number | null;
            next_page?: number | null;
            first_page?: boolean;
        };
        /**
         * Metadata
         * @description Additional metadata key-value pairs
         */
        Metadata: {
            [key: string]: string | null;
        };
        Error: {
            errors: {
                [key: string]: string[];
            };
        };
        /**
         * @description Decoded JWT payload for embed token responses.
         *
         *     Payment intent tokens include `account_id` and `payment_intent_id`.
         *     Setup intent tokens include `organization_id` and `setup_intent_id`
         *     and do not use `account_id`. Unused fields are null.
         */
        EmbedTokenJwt: {
            /**
             * Format: uuid
             * @description Present for payment intent embed tokens. Null for setup intents.
             */
            account_id?: string | null;
            /**
             * Format: uuid
             * @description Present for setup intent embed tokens. Null for payment intents.
             */
            organization_id?: string | null;
            /**
             * Format: uuid
             * @description Present for payment intent embed tokens. Null for setup intents.
             */
            payment_intent_id?: string | null;
            /**
             * Format: uuid
             * @description Present for setup intent embed tokens. Null for payment intents.
             */
            setup_intent_id?: string | null;
        };
        /** @description Decoded JWT payload for render token responses. */
        RenderTokenJwt: {
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethod"][];
            billing_address_options?: components["schemas"]["BillingAddressOptions"];
            env?: string;
            origins?: string[];
            /** Format: uuid */
            render_template_id?: string;
        };
        EmbedToken: {
            /**
             * @description JWT string used for embedded payment and setup intent flows.
             *     When decoded, the JWT payload matches the EmbedTokenJwt schema.
             *     Setup intent tokens are organization-scoped (`organization_id` +
             *     `setup_intent_id`). Payment intent tokens remain account-scoped
             *     (`account_id` + `payment_intent_id`).
             */
            token?: string;
            ttl?: number;
        };
        RenderToken: {
            /** @description JWT string used for render template initialization. When decoded, the JWT payload matches the RenderTokenJwt schema. */
            token?: string;
            ttl?: number;
        };
        BankAccountProfileInput: {
            /** @description Account holder name. Letters, spaces, hyphens, apostrophes, and periods only. */
            account_holder_name?: string;
            account_holder_type?: string;
            account_type?: string;
            bank_name?: string;
            currency?: string;
            /** @description Plaintext bank account number. Stored encrypted at rest. Not returned in API responses. */
            account_number?: string;
            encrypted_account_number?: string;
            routing_number?: string;
        };
        BankAccountProfile: {
            /** @description Account holder name. Letters, spaces, hyphens, apostrophes, and periods only. */
            account_holder_name?: string;
            account_holder_type?: string;
            account_type?: string;
            bank_name?: string;
            /** @enum {string|null} */
            failure_reason?: "activation_failed" | "processing_error" | "vault_failed" | "insufficient_funds" | "verification_failed" | null;
            fingerprint?: string | null;
            last4?: string;
            routing_number?: string;
            state?: string;
            token?: string;
            /** @description True when the bank account was verified via Plaid Auth. */
            verified?: boolean;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        BillingAddressInput: {
            address_line1?: string;
            address_line2?: string | null;
            city?: string;
            country?: string;
            email?: string;
            name?: string;
            phone?: string;
            postal_code?: string;
            state?: string;
        };
        BillingAddress: {
            address_line1?: string;
            address_line2?: string | null;
            city?: string;
            country?: string;
            email?: string;
            name?: string;
            phone?: string;
            postal_code?: string;
            state?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        MailingAddressInput: {
            address_line1?: string;
            address_line2?: string | null;
            city?: string;
            country?: string;
            name?: string;
            postal_code?: string;
            state?: string;
        };
        MailingAddress: {
            address_line1?: string;
            address_line2?: string | null;
            city?: string;
            country?: string;
            name?: string;
            postal_code?: string;
            state?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CardProfileInput: {
            /** @description Cardholder name. Letters, spaces, hyphens, apostrophes, and periods only. */
            card_holder_name?: string;
            cvc?: string;
            encrypted_card_number?: string;
            exp_month?: number;
            exp_year?: number;
            moto?: boolean;
        };
        /** @description Apple Pay card profile for embed confirm. Clients only send wallet_payload (the raw JSON-encoded PKPaymentToken). wallet_provider is derived from the payment method type. Brand, last4, expiration, pan_type, and cryptogram are set from the Vault response. Encrypted PAN and client-supplied cryptogram are not supported. */
        ApplePayCardProfileInput: {
            /** @description The unmodified JSON-encoded PKPaymentToken. */
            wallet_payload: string;
        };
        /** @description Google Pay card profile for embed confirm. Clients only send wallet_payload. wallet_provider is derived from the payment method type. Brand, last4, expiration, pan_type, and cryptogram are set from the Vault response. Encrypted PAN is not supported. */
        GooglePayCardProfileInput: {
            /** @description The unmodified Google Pay payment token payload. */
            wallet_payload: string;
        };
        CardProfile: {
            avs_check?: string;
            avs_check_message?: string | null;
            brand?: string;
            /** @description Cardholder name. Letters, spaces, hyphens, apostrophes, and periods only. */
            card_holder_name?: string;
            cvc_check?: string;
            cvc_check_message?: string | null;
            exp_month?: number;
            exp_year?: number;
            /** @enum {string|null} */
            failure_reason?: "authorization_failed" | "avs_blocked" | "brand_not_allowed" | "brand_not_found" | "cvc_blocked" | "processing_error" | "vault_failed" | null;
            first6?: string;
            funding?: string | null;
            fingerprint?: string | null;
            last4?: string;
            state?: string;
            three_d_secure_supported?: boolean | null;
            token?: string;
            wallet_provider?: components["schemas"]["WalletProviderType"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        UpdateAccountInput: {
            mcc?: string;
        };
        UpdateAccountRequest: {
            account: components["schemas"]["UpdateAccountInput"];
        };
        Account: {
            /** Format: uuid */
            id?: string;
            name?: string;
            /** Format: uuid */
            merchant_id?: string;
            /** Format: uuid */
            processor_id?: string;
            worldpay_mid?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        Charge: {
            id?: string;
            /** Format: uuid */
            account_id?: string;
            adjustment_reason?: string;
            amount?: number;
            currency?: string;
            /** Format: uuid */
            customer_id?: string;
            description?: string | null;
            /** @enum {string|null} */
            allowed_reverse_action?: "void" | "refund" | null;
            metadata?: components["schemas"]["Metadata"];
            /** Format: uuid */
            original_transaction_id?: string;
            /** Format: uuid */
            parent_transaction_id?: string;
            /** Format: uuid */
            payment_intent_id?: string;
            /** Format: uuid */
            payment_method_id?: string;
            platform_fee?: number;
            source?: components["schemas"]["TransactionSourceType"];
            /** @enum {string} */
            state?: "cancelled" | "errored" | "failed" | "processing" | "requires_capture" | "requires_confirmation" | "requires_review" | "settlement_failed" | "succeeded";
            statement_descriptor?: string;
            /** Format: date-time */
            succeeded_at?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateCustomerInput: {
            /** Format: uuid */
            account_id?: string;
            name?: string;
            email?: string;
            phone?: string;
            mailing_address_attributes?: components["schemas"]["MailingAddressInput"];
            metadata?: components["schemas"]["Metadata"];
        };
        CreateCustomerRequest: {
            customer: components["schemas"]["CreateCustomerInput"];
        };
        UpdateCustomerInput: {
            email?: string;
            name?: string;
            /** Format: uuid */
            payment_method_id?: string;
            phone?: string;
            mailing_address_attributes?: components["schemas"]["MailingAddressInput"];
            metadata?: components["schemas"]["Metadata"];
        };
        UpdateCustomerRequest: {
            customer: components["schemas"]["UpdateCustomerInput"];
        };
        Customer: {
            /** Format: uuid */
            id?: string;
            email?: string;
            metadata?: components["schemas"]["Metadata"];
            name?: string;
            /** Format: uuid */
            organization_id?: string;
            /** Format: uuid */
            payment_method_id?: string;
            phone?: string;
            type?: string;
            mailing_address?: components["schemas"]["MailingAddress"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateDunningConfigurationInput: {
            /** @description Days after a failed collection to retry, in ascending order. */
            retry_days: number[];
            enabled?: boolean;
        };
        CreateDunningConfigurationRequest: {
            dunning_configuration: components["schemas"]["CreateDunningConfigurationInput"];
        };
        UpdateDunningConfigurationInput: {
            retry_days?: number[];
            enabled?: boolean;
        };
        UpdateDunningConfigurationRequest: {
            dunning_configuration: components["schemas"]["UpdateDunningConfigurationInput"];
        };
        DunningConfiguration: {
            /** Format: uuid */
            id?: string;
            retry_days?: number[];
            enabled?: boolean;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateExternalAccountInput: {
            metadata?: components["schemas"]["Metadata"];
            external_billing_address_attributes?: components["schemas"]["BillingAddressInput"];
            external_bank_account_profile_attributes?: components["schemas"]["BankAccountProfileInput"];
            external_card_profile_attributes?: components["schemas"]["CardProfileInput"];
        };
        CreateExternalAccountRequest: {
            external_account: components["schemas"]["CreateExternalAccountInput"];
        };
        ExternalAccount: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organization_id?: string;
            metadata?: components["schemas"]["Metadata"];
            /** @enum {string} */
            type?: "external_card" | "external_bank_account";
            external_bank_account_profile?: components["schemas"]["BankAccountProfile"];
            external_card_profile?: components["schemas"]["CardProfile"];
            external_billing_address?: components["schemas"]["BillingAddress"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateFileUploadInput: {
            content_type: string;
            file_name: string;
            purpose: string;
        };
        CreateFileUploadRequest: {
            file: components["schemas"]["CreateFileUploadInput"];
        };
        FileDownload: {
            /** Format: uuid */
            id: string;
            content_type: string;
            file_name: string;
            purpose: string;
            state: string;
            download: components["schemas"]["FileDownloadConfiguration"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        FileDownloadConfiguration: {
            /** Format: uri */
            url: string;
            method: string;
            /** Format: date-time */
            expires_at: string;
        };
        FileUpload: {
            /** Format: uuid */
            id: string;
            content_type: string;
            file_name: string;
            purpose: string;
            state: string;
            upload: components["schemas"]["FileUploadConfiguration"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        FileUploadConfiguration: {
            /** Format: uri */
            url: string;
            method: string;
            headers: {
                [key: string]: string;
            };
            /** Format: date-time */
            expires_at: string;
        };
        CreateLegalEntityApplicationDocumentInput: {
            /** Format: uuid */
            legal_entity_application_id?: string;
            document_type?: components["schemas"]["LegalEntityDocumentType"];
            /** Format: uuid */
            file_upload_id?: string;
        };
        CreateLegalEntityApplicationDocumentRequest: {
            legal_entity_application_document: components["schemas"]["CreateLegalEntityApplicationDocumentInput"];
        };
        LegalEntityApplicationDocument: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            legal_entity_application_id?: string;
            document_type?: components["schemas"]["LegalEntityDocumentType"];
            /** Format: uuid */
            file_upload_id?: string;
            file_name?: string;
            byte_size?: number;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateLegalEntityApplicationPrincipalInput: {
            /** Format: uuid */
            legal_entity_application_id?: string;
            title?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            tax_id?: string;
            date_of_birth?: string;
            address_line1?: string;
            address_line2?: string;
            city?: string;
            state?: string;
            country?: string;
            postal_code?: string;
            stake_percent?: number;
            contact_phone?: string;
        };
        CreateLegalEntityApplicationPrincipalRequest: {
            legal_entity_application_principal: components["schemas"]["CreateLegalEntityApplicationPrincipalInput"];
        };
        LegalEntityApplicationPrincipal: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            legal_entity_application_id?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            date_of_birth?: string;
            address_line1?: string;
            address_line2?: string;
            city?: string;
            state?: string;
            country?: string;
            postal_code?: string;
            stake_percent?: number;
            contact_phone?: string;
            tax_id_last4?: string;
            title?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        LegalEntityPrincipal: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            legal_entity_id?: string;
            title?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            date_of_birth?: string;
            address_line1?: string;
            address_line2?: string;
            city?: string;
            state?: string;
            country?: string;
            postal_code?: string;
            contact_phone?: string;
            tax_id_last4?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        /** @enum {string} */
        LegalEntityEntityType: "individual_sole_proprietorship" | "corporation" | "limited_liability_company" | "partnership" | "limited_partnership" | "general_partnership" | "tax_exempt_organization" | "government_agency";
        /** @enum {string} */
        LegalEntityOwnershipType: "public" | "private";
        /** @enum {string} */
        LegalEntityDocumentType: "irs_cp_575";
        /** @enum {string} */
        MerchantBusinessCategoryType: "business_association" | "charity" | "church" | "county" | "federal" | "fraternal_org" | "government" | "higher_education" | "k12" | "labor_union" | "local" | "ministry" | "pac" | "parachurch" | "party" | "preschool" | "social_club" | "social_welfare" | "state" | "tribal" | "vendor" | "veterans_org";
        /**
         * @description How funds are captured after payment confirmation.
         *     `automatic` performs a sale (authorize and capture together).
         *     `automatic_async` authorizes then captures asynchronously.
         *     `manual` authorizes only; capture must be requested separately.
         * @enum {string}
         */
        PaymentIntentCaptureMethodType: "automatic" | "automatic_async" | "manual";
        /** @enum {string} */
        PaymentLinkAmountType: "fixed" | "open";
        /** @enum {string} */
        PaymentMethodType: "card" | "bank_account" | "googlepay" | "applepay";
        /**
         * @description US state code (50 states; excludes DC and territories).
         * @enum {string}
         */
        UsStateType: "AK" | "AL" | "AR" | "AZ" | "CA" | "CO" | "CT" | "DE" | "FL" | "GA" | "HI" | "IA" | "ID" | "IL" | "IN" | "KS" | "KY" | "LA" | "MA" | "MD" | "ME" | "MI" | "MN" | "MO" | "MS" | "MT" | "NC" | "ND" | "NE" | "NH" | "NJ" | "NM" | "NV" | "NY" | "OH" | "OK" | "OR" | "PA" | "RI" | "SC" | "SD" | "TN" | "TX" | "UT" | "VA" | "VT" | "WA" | "WI" | "WV" | "WY";
        /** @description Restrict billing addresses to selected US states. */
        UsOnlyBillingAddressOptions: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            mode: "us_only";
            allowed_states: components["schemas"]["UsStateType"][];
        };
        /** @description Restrict billing addresses to selected countries. */
        InternationalBillingAddressOptions: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            mode: "international";
            allowed_countries: string[];
        };
        /** @description Billing address collection restrictions for a render template. */
        BillingAddressOptions: components["schemas"]["UsOnlyBillingAddressOptions"] | components["schemas"]["InternationalBillingAddressOptions"];
        /** @description Payment method details used when confirming an embedded intent with a new payment method. */
        EmbedConfirmPaymentMethodInput: components["schemas"]["EmbedConfirmCardPaymentMethodInput"] | components["schemas"]["EmbedConfirmBankAccountPaymentMethodInput"] | components["schemas"]["EmbedConfirmGooglePayPaymentMethodInput"] | components["schemas"]["EmbedConfirmApplePayPaymentMethodInput"];
        EmbedConfirmCardPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "card";
            metadata?: components["schemas"]["Metadata"];
            billing_address_attributes?: components["schemas"]["BillingAddressInput"];
            card_profile_attributes: components["schemas"]["CardProfileInput"];
        };
        /** @description Confirm an embedded intent with a bank account. When ACH verification is required for the intent amount, include plaid credentials and omit bank_account_profile_attributes; routing and account numbers are filled server-side from Plaid Auth. Otherwise provide encrypted_account_number and routing_number on bank_account_profile_attributes. */
        EmbedConfirmBankAccountPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "bank_account";
            metadata?: components["schemas"]["Metadata"];
            plaid?: components["schemas"]["PlaidCredentialsInput"];
            bank_account_profile_attributes?: components["schemas"]["BankAccountProfileInput"];
            billing_address_attributes?: components["schemas"]["BillingAddressInput"];
        };
        EmbedConfirmGooglePayPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "googlepay";
            metadata?: components["schemas"]["Metadata"];
            billing_address_attributes?: components["schemas"]["BillingAddressInput"];
            card_profile_attributes: components["schemas"]["GooglePayCardProfileInput"];
        };
        EmbedConfirmApplePayPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "applepay";
            metadata?: components["schemas"]["Metadata"];
            billing_address_attributes?: components["schemas"]["BillingAddressInput"];
            card_profile_attributes: components["schemas"]["ApplePayCardProfileInput"];
        };
        /** @description One-time Plaid Link credentials used to source and verify a bank account when ACH verification is required. */
        PlaidCredentialsInput: {
            /** @description Temporary public_token returned by Plaid Link onSuccess. */
            public_token: string;
            /** @description Selected Plaid account_id from Link metadata. */
            account_id: string;
        };
        AllowedCardPaymentMethodOptions: {
            /** @description When true, this surface supports MOTO card entry (cardholder not present). Only supported on render templates. */
            moto?: boolean;
        };
        AllowedBankAccountPaymentMethodOptions: {
            /** @description When true, this surface collects bank account verification (Plaid) for ACH at or above the merchant ACH threshold. When omitted or false, verification is off. Only supported on render templates. */
            verification?: boolean;
        };
        /** @description No configurable options for Google Pay payment methods. */
        AllowedGooglePayPaymentMethodOptions: Record<string, never>;
        /** @description No configurable options for Apple Pay payment methods. */
        AllowedApplePayPaymentMethodOptions: Record<string, never>;
        AllowedCardPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "card";
            options?: components["schemas"]["AllowedCardPaymentMethodOptions"];
        };
        AllowedBankAccountPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "bank_account";
            options?: components["schemas"]["AllowedBankAccountPaymentMethodOptions"];
        };
        AllowedGooglePayPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "googlepay";
            options?: components["schemas"]["AllowedGooglePayPaymentMethodOptions"];
        };
        AllowedApplePayPaymentMethodInput: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "applepay";
            options?: components["schemas"]["AllowedApplePayPaymentMethodOptions"];
        };
        /** @description Payment method allowed on a render template, payment link, or merchant application. */
        AllowedPaymentMethodInput: components["schemas"]["AllowedCardPaymentMethodInput"] | components["schemas"]["AllowedBankAccountPaymentMethodInput"] | components["schemas"]["AllowedGooglePayPaymentMethodInput"] | components["schemas"]["AllowedApplePayPaymentMethodInput"];
        AllowedCardPaymentMethod: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "card";
            options: components["schemas"]["AllowedCardPaymentMethodOptions"];
        };
        AllowedBankAccountPaymentMethod: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "bank_account";
            options: components["schemas"]["AllowedBankAccountPaymentMethodOptions"];
        };
        AllowedGooglePayPaymentMethod: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "googlepay";
            options: components["schemas"]["AllowedGooglePayPaymentMethodOptions"];
        };
        AllowedApplePayPaymentMethod: {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "applepay";
            options: components["schemas"]["AllowedApplePayPaymentMethodOptions"];
        };
        /** @description Allowed payment method returned in API responses and render token JWT payloads. */
        AllowedPaymentMethod: components["schemas"]["AllowedCardPaymentMethod"] | components["schemas"]["AllowedBankAccountPaymentMethod"] | components["schemas"]["AllowedGooglePayPaymentMethod"] | components["schemas"]["AllowedApplePayPaymentMethod"];
        /** @enum {string} */
        PayoutDirectionType: "credit" | "debit";
        /** @enum {string} */
        PayoutStateType: "pending" | "processing" | "succeeded" | "failed" | "errored" | "accepted" | "rejected";
        /** @enum {string} */
        RefundStateType: "pending" | "processing" | "requires_review" | "succeeded" | "cancelled" | "failed";
        /** @enum {string} */
        SubscriptionIntervalType: "day" | "week" | "month" | "year";
        /** @enum {string} */
        SubscriptionPlanType: "fixed" | "variable";
        /** @enum {string} */
        TransactionSourceType: "api" | "dashboard" | "iframe" | "system" | "subscription" | "admin";
        /** @enum {string} */
        WalletProviderType: "googlepay" | "applepay";
        /** @enum {string} */
        WebhookEventType: "charge.cancelled" | "charge.created" | "charge.errored" | "charge.failed" | "charge.processing" | "charge.requires_capture" | "charge.requires_confirmation" | "charge.requires_review" | "charge.settlement_failed" | "charge.succeeded" | "customer.created" | "customer.updated" | "legal_entity.created" | "legal_entity.updated" | "legal_entity_principal.created" | "legal_entity_principal.updated" | "legal_entity_application.approved" | "legal_entity_application.denied" | "legal_entity_application.needs_information" | "legal_entity_application.pending" | "legal_entity_application.submitted" | "merchant.created" | "merchant.updated" | "payment_intent.cancelled" | "payment_intent.created" | "payment_intent.errored_authorization" | "payment_intent.errored_capture" | "payment_intent.errored_sale" | "payment_intent.processing_authorization" | "payment_intent.processing_capture" | "payment_intent.processing_sale" | "payment_intent.requires_capture" | "payment_intent.requires_confirmation" | "payment_intent.requires_payment_method" | "payment_intent.requires_review" | "payment_intent.succeeded" | "processor_transaction.completed" | "reconciliation.created" | "refund.cancelled" | "refund.created" | "refund.failed" | "refund.pending" | "refund.processing" | "refund.requires_review" | "refund.succeeded" | "setup_intent.cancelled" | "setup_intent.created" | "setup_intent.errored" | "setup_intent.failed" | "setup_intent.requires_confirmation" | "setup_intent.requires_payment_method" | "setup_intent.requires_review" | "setup_intent.succeeded" | "setup_intent.verifying" | "void.created" | "void.failed" | "void.pending" | "void.processing" | "void.requires_review" | "void.succeeded";
        CreateLegalEntityApplicationInput: {
            legal_name?: string;
            entity_type?: components["schemas"]["LegalEntityEntityType"];
            ownership_type?: components["schemas"]["LegalEntityOwnershipType"];
            tax_id?: string;
            contact_email?: string;
            contact_phone?: string;
            business_address_line1?: string;
            business_address_line2?: string;
            business_city?: string;
            business_state?: string;
            business_postal_code?: string;
            business_country?: string;
        };
        CreateLegalEntityApplicationRequest: {
            legal_entity_application: components["schemas"]["CreateLegalEntityApplicationInput"];
        };
        LegalEntityApplicationRequirement: {
            /** Format: uuid */
            id?: string;
            requirement_type?: string;
            state?: string;
            message?: string;
            reason_code?: string | null;
            /** Format: date-time */
            satisfied_at?: string | null;
            /** Format: date-time */
            waived_at?: string | null;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        LegalEntity: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organization_id?: string;
            legal_name?: string;
            /** Format: uuid */
            parent_legal_entity_id?: string | null;
            entity_type?: components["schemas"]["LegalEntityEntityType"];
            ownership_type?: components["schemas"]["LegalEntityOwnershipType"];
            contact_email?: string;
            contact_phone?: string;
            business_address_line1?: string;
            business_address_line2?: string | null;
            business_city?: string;
            business_state?: string;
            business_postal_code?: string;
            business_country?: string;
            tax_id_last4?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        LegalEntityApplication: {
            /** Format: uuid */
            id?: string;
            legal_name?: string;
            /** Format: uuid */
            legal_entity_id?: string;
            entity_type?: components["schemas"]["LegalEntityEntityType"];
            ownership_type?: components["schemas"]["LegalEntityOwnershipType"];
            contact_email?: string;
            contact_phone?: string;
            business_address_line1?: string;
            business_address_line2?: string | null;
            business_city?: string;
            business_state?: string;
            business_postal_code?: string;
            business_country?: string;
            state?: string;
            tax_id_last4?: string;
            /** Format: date-time */
            approved_at?: string | null;
            /** Format: date-time */
            denied_at?: string | null;
            /** Format: date-time */
            needs_information_at?: string | null;
            decision_reason?: string | null;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
            requirements?: components["schemas"]["LegalEntityApplicationRequirement"][];
        };
        CreateMerchantApplicationInput: {
            annual_credit_card_sales_volume?: number;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethodInput"][];
            bank_account_number?: string;
            bank_routing_number?: string;
            business_category?: components["schemas"]["MerchantBusinessCategoryType"];
            business_description?: string;
            city?: string;
            country_code?: string;
            customer_service_number?: string;
            dba_name?: string;
            /** Format: uuid */
            legal_entity_application_id?: string;
            max_transaction_amount?: number;
            postal_code?: string;
            primary_contact_email_address?: string;
            primary_contact_first_name?: string;
            primary_contact_last_name?: string;
            primary_contact_phone?: string;
            state_province?: string;
            street_address1?: string;
            street_address2?: string;
            website_url?: string;
        };
        CreateMerchantApplicationRequest: {
            merchant_application: components["schemas"]["CreateMerchantApplicationInput"];
        };
        MerchantApplication: {
            /** Format: uuid */
            id?: string;
            annual_credit_card_sales_volume?: number;
            business_category?: components["schemas"]["MerchantBusinessCategoryType"];
            business_description?: string;
            city?: string;
            country_code?: string;
            customer_service_number?: string;
            dba_name?: string;
            echeck_billing_descriptor?: string;
            echeck_company_name?: string;
            echeck_enabled?: string;
            hard_coded_billing_descriptor?: string;
            has_accepted_credit_cards?: boolean;
            /** Format: uuid */
            legal_entity_application_id?: string;
            max_daily_credits_amount?: number;
            max_daily_debits_amount?: number;
            max_monthly_credits_amount?: number;
            max_monthly_debits_amount?: number;
            max_single_debit_amount?: number;
            max_transaction_amount?: string;
            mcc?: string;
            postal_code?: string;
            primary_contact_email_address?: string;
            primary_contact_first_name?: string;
            primary_contact_last_name?: string;
            primary_contact_phone?: string;
            purchase_currency?: string;
            settlement_currency?: string;
            settlement_days?: number;
            state_province?: string;
            street_address1?: string;
            street_address2?: string;
            website_url?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        Merchant: {
            /** Format: uuid */
            id?: string;
            active?: boolean;
            /** Format: uuid */
            organization_id?: string;
            /** Format: uuid */
            legal_entity_id?: string;
            annual_credit_card_sales_volume?: number;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethod"][];
            business_category?: components["schemas"]["MerchantBusinessCategoryType"];
            business_description?: string;
            city?: string;
            country_code?: string;
            customer_service_number?: string;
            has_accepted_credit_cards?: boolean;
            dba_name?: string;
            echeck_billing_descriptor?: string;
            echeck_company_name?: string;
            echeck_enabled?: boolean;
            hard_coded_billing_descriptor?: string;
            max_transaction_amount?: number;
            /** Format: uuid */
            merchant_application_id?: string;
            mcc?: string;
            naics_code?: string;
            postal_code?: string;
            primary_contact_email_address?: string;
            primary_contact_first_name?: string;
            primary_contact_last_name?: string;
            primary_contact_phone?: string;
            purchase_currency?: string;
            settlement_currency?: string;
            state_province?: string;
            street_address1?: string;
            street_address2?: string;
            sub_merchant_id?: string;
            website_url?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        Organization: {
            /** Format: uuid */
            id?: string;
            name?: string;
            slug?: string;
            /** @enum {string} */
            kind?: "direct" | "payfac";
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        UpdateOrganizationInput: {
            /** @description Globally unique public slug used in payment link URLs. Changing this breaks existing `/payment_links/{organization_slug}/...` links. */
            slug: string;
        };
        UpdateOrganizationRequest: {
            organization: components["schemas"]["UpdateOrganizationInput"];
        };
        CreateOriginInput: {
            value?: string;
        };
        CreateOriginRequest: {
            origin: components["schemas"]["CreateOriginInput"];
        };
        /** @enum {string} */
        OriginApplepayRegistrationStateType: "pending" | "skipped" | "registered" | "failed";
        Origin: {
            /** Format: uuid */
            id?: string;
            value?: string;
            /** @description Apple Pay merchant-domain registration status for this origin host. Null until registration is enabled. */
            applepay_registration_state?: components["schemas"]["OriginApplepayRegistrationStateType"] | null;
            /** @description Last Apple Pay registration or unregistration error, if any */
            applepay_registration_error?: string | null;
            /**
             * Format: date-time
             * @description When this origin host was last registered with Apple Pay
             */
            applepay_registered_at?: string | null;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreatePaymentIntentInput: {
            amount: number;
            capture_method?: components["schemas"]["PaymentIntentCaptureMethodType"];
            /** Format: uuid */
            customer_id?: string;
            description?: string | null;
            statement_descriptor?: string;
            metadata?: components["schemas"]["Metadata"];
            recurring_payment?: components["schemas"]["RecurringPayment"];
        };
        CreatePaymentIntentRequest: {
            payment_intent: components["schemas"]["CreatePaymentIntentInput"];
        };
        ConfirmPaymentIntentWithPaymentMethodIdInput: {
            /** Format: uuid */
            payment_method_id: string;
        };
        ConfirmPaymentIntentWithEmbeddedPaymentMethodInput: {
            payment_method: components["schemas"]["EmbedConfirmPaymentMethodInput"];
        };
        ConfirmPaymentIntentWithPaymentMethodInput: components["schemas"]["ConfirmPaymentIntentWithPaymentMethodIdInput"] | components["schemas"]["ConfirmPaymentIntentWithEmbeddedPaymentMethodInput"];
        ConfirmPaymentIntentWithPaymentMethodRequest: {
            payment_intent: components["schemas"]["ConfirmPaymentIntentWithPaymentMethodInput"];
        };
        UpdatePaymentIntentInput: {
            /** Format: uuid */
            payment_method_id?: string;
            amount?: number;
            metadata?: components["schemas"]["Metadata"];
            recurring_payment?: components["schemas"]["RecurringPayment"];
        };
        UpdatePaymentIntentRequest: {
            payment_intent: components["schemas"]["UpdatePaymentIntentInput"];
        };
        PaymentIntent: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            account_id?: string;
            amount?: number;
            capture_method?: components["schemas"]["PaymentIntentCaptureMethodType"];
            /** Format: uuid */
            charge_id?: string;
            currency?: string;
            /** Format: uuid */
            customer_id?: string;
            description?: string;
            metadata?: components["schemas"]["Metadata"];
            recurring_payment?: components["schemas"]["RecurringPayment"];
            /** Format: uuid */
            payment_method_id?: string;
            /** @enum {string} */
            state?: "requires_payment_method" | "requires_confirmation" | "requires_capture" | "processing_authorization" | "processing_capture" | "processing_sale" | "requires_review" | "succeeded" | "cancelled" | "errored_authorization" | "errored_capture" | "errored_sale";
            statement_descriptor?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        /** @description How this payment intent relates to a recurring series. Use `initial` for the first charge that establishes the series. Use `network_transaction_id` and/or `transaction_link_id` for subsequent merchant-initiated charges. Do not combine `initial` with network identifiers on the same request. */
        RecurringPayment: {
            /** @description When true, marks the first payment in a recurring series so the processor can treat it as an initial recurring / credential-on-file setup transaction. */
            initial?: boolean;
            /** @description Network transaction id from the initial recurring charge, used for subsequent merchant-initiated payments. */
            network_transaction_id?: string;
            /** @description Processor transaction link id for subsequent recurring payments where supported. */
            transaction_link_id?: string;
        };
        CreatePaymentLinkInput: {
            slug?: string;
            active?: boolean;
            amount_type?: components["schemas"]["PaymentLinkAmountType"];
            amount?: number;
            /** Format: uri */
            image_url?: string;
            minimum_amount?: number;
            maximum_amount?: number;
            suggested_amounts?: number[];
            currency?: string;
            description?: string | null;
            statement_descriptor?: string;
            /** Format: uri */
            success_url?: string;
            title?: string;
            /** Format: uri */
            cancel_url?: string;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethodInput"][];
            metadata?: components["schemas"]["Metadata"];
        };
        CreatePaymentLinkRequest: {
            payment_link: components["schemas"]["CreatePaymentLinkInput"];
        };
        UpdatePaymentLinkInput: {
            active?: boolean;
            amount_type?: components["schemas"]["PaymentLinkAmountType"];
            amount?: number;
            /** Format: uri */
            image_url?: string;
            minimum_amount?: number;
            maximum_amount?: number;
            suggested_amounts?: number[];
            currency?: string;
            description?: string | null;
            statement_descriptor?: string;
            /** Format: uri */
            success_url?: string;
            title?: string;
            /** Format: uri */
            cancel_url?: string;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethodInput"][];
            metadata?: components["schemas"]["Metadata"];
        };
        UpdatePaymentLinkRequest: {
            payment_link: components["schemas"]["UpdatePaymentLinkInput"];
        };
        PaymentLink: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organization_id?: string;
            organization_slug?: string;
            /** Format: uuid */
            account_id?: string;
            slug?: string;
            active?: boolean;
            amount_type?: components["schemas"]["PaymentLinkAmountType"];
            amount?: number;
            /** Format: uri */
            image_url?: string;
            minimum_amount?: number;
            maximum_amount?: number;
            suggested_amounts?: number[];
            currency?: string;
            description?: string | null;
            statement_descriptor?: string;
            /** Format: uri */
            success_url?: string;
            title?: string;
            /** Format: uri */
            cancel_url?: string;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethod"][];
            metadata?: components["schemas"]["Metadata"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreatePaymentMethodInput: {
            /** Format: uuid */
            customer_id?: string;
            metadata?: components["schemas"]["Metadata"];
            billing_address_attributes?: components["schemas"]["BillingAddressInput"];
            card_profile_attributes?: {
                brand?: string;
                /** @description Cardholder name. Letters, spaces, hyphens, apostrophes, and periods only. */
                card_holder_name?: string;
                cvc?: string;
                encrypted_card_number?: string;
                exp_month?: number;
                exp_year?: number;
                first6?: string;
                last4?: string;
                pan_type?: string;
                token?: string;
                wallet_payload?: string;
                wallet_provider?: components["schemas"]["WalletProviderType"];
            };
            bank_account_profile_attributes?: {
                last4?: string;
                /** @description Account holder name. Letters, spaces, hyphens, apostrophes, and periods only. */
                account_holder_name?: string;
                account_holder_type?: string;
                account_type?: string;
                bank_name?: string;
                currency?: string;
                account_number?: string;
                encrypted_account_number?: string;
                token?: string;
                routing_number?: string;
            };
        };
        CreatePaymentMethodRequest: {
            payment_method: components["schemas"]["CreatePaymentMethodInput"];
        };
        UpdateMerchantInput: {
            active?: boolean;
            business_category?: components["schemas"]["MerchantBusinessCategoryType"];
            dba_name?: string;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethodInput"][];
        };
        UpdateMerchantRequest: {
            merchant: components["schemas"]["UpdateMerchantInput"];
        };
        UpdateLegalEntityApplicationInput: {
            legal_name?: string;
            entity_type?: components["schemas"]["LegalEntityEntityType"];
            ownership_type?: components["schemas"]["LegalEntityOwnershipType"];
            tax_id?: string;
            contact_email?: string;
            contact_phone?: string;
            business_address_line1?: string;
            business_address_line2?: string;
            business_city?: string;
            business_state?: string;
            business_postal_code?: string;
            business_country?: string;
        };
        UpdateLegalEntityApplicationRequest: {
            legal_entity_application: components["schemas"]["UpdateLegalEntityApplicationInput"];
        };
        UpdateLegalEntityApplicationPrincipalInput: {
            title?: string;
            first_name?: string;
            last_name?: string;
            email?: string;
            tax_id?: string;
            date_of_birth?: string;
            address_line1?: string;
            address_line2?: string;
            city?: string;
            state?: string;
            country?: string;
            postal_code?: string;
            stake_percent?: number;
            contact_phone?: string;
        };
        UpdateLegalEntityApplicationPrincipalRequest: {
            legal_entity_application_principal: components["schemas"]["UpdateLegalEntityApplicationPrincipalInput"];
        };
        UpdateMerchantApplicationInput: {
            annual_credit_card_sales_volume?: number;
            bank_account_number?: string;
            bank_routing_number?: string;
            business_category?: components["schemas"]["MerchantBusinessCategoryType"];
            business_description?: string;
            city?: string;
            country_code?: string;
            customer_service_number?: string;
            dba_name?: string;
            max_transaction_amount?: number;
            postal_code?: string;
            primary_contact_email_address?: string;
            primary_contact_first_name?: string;
            primary_contact_last_name?: string;
            primary_contact_phone?: string;
            state_province?: string;
            street_address1?: string;
            street_address2?: string;
            website_url?: string;
        };
        UpdateMerchantApplicationRequest: {
            merchant_application: components["schemas"]["UpdateMerchantApplicationInput"];
        };
        PaymentMethod: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            customer_id?: string;
            metadata?: components["schemas"]["Metadata"];
            type?: components["schemas"]["PaymentMethodType"];
            bank_account_profile?: components["schemas"]["BankAccountProfile"];
            billing_address?: components["schemas"]["BillingAddress"];
            card_profile?: components["schemas"]["CardProfile"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreatePayoutInput: {
            /** Format: uuid */
            external_account_id: string;
            amount: number;
            currency?: string;
            direction: components["schemas"]["PayoutDirectionType"];
            prefix?: string;
            addenda?: string | null;
            metadata?: components["schemas"]["Metadata"];
        };
        CreatePayoutRequest: {
            payout: components["schemas"]["CreatePayoutInput"];
        };
        CreateBulkPayoutInput: {
            /** Format: uuid */
            account_id: string;
            /** Format: uuid */
            external_account_id: string;
            amount: number;
            currency?: string;
            direction: components["schemas"]["PayoutDirectionType"];
            prefix?: string;
            addenda?: string | null;
            metadata?: components["schemas"]["Metadata"];
        };
        CreateBulkPayoutsRequest: {
            payouts: components["schemas"]["CreateBulkPayoutInput"][];
        };
        Payout: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            account_id?: string;
            addenda?: string | null;
            /** Format: uuid */
            external_account_id?: string;
            amount?: number;
            currency?: string;
            direction?: components["schemas"]["PayoutDirectionType"];
            metadata?: components["schemas"]["Metadata"];
            /** Format: uuid */
            organization_id?: string;
            prefix?: string;
            public_id?: string;
            state?: components["schemas"]["PayoutStateType"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        ProcessorTransaction: {
            /** Format: uuid */
            id?: string;
            /**
             * Format: uuid
             * @description Account the transaction was processed under. Null for setup intent verifications, which are scoped to the organization.
             */
            account_id?: string | null;
            /**
             * Format: uuid
             * @description Organization the transaction belongs to.
             */
            organization_id?: string | null;
            approved?: boolean;
            avs_check?: string;
            avs_check_message?: string;
            cvc_check?: string;
            cvc_check_message?: string;
            external_reference?: string;
            metadata?: components["schemas"]["Metadata"];
            /** Format: uuid */
            payment_method_id?: string;
            /** Format: uuid */
            payment_transaction_id?: string;
            /** @enum {string} */
            payment_transaction_type?: "charge" | "refund" | "void";
            processor_reference?: string;
            network_transaction_id?: string;
            transaction_link_id?: string;
            /** @enum {string} */
            transaction_type?: "authorization" | "authorization_reversal" | "capture" | "credit" | "echeck_credit" | "echeck_sale" | "echeck_void" | "sale" | "void";
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateProductInput: {
            name: string;
            description: string;
            active?: boolean;
            metadata?: components["schemas"]["Metadata"];
        };
        CreateProductRequest: {
            product: components["schemas"]["CreateProductInput"];
        };
        UpdateProductInput: {
            name?: string;
            description?: string;
            active?: boolean;
            metadata?: components["schemas"]["Metadata"];
        };
        UpdateProductRequest: {
            product: components["schemas"]["UpdateProductInput"];
        };
        Product: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            account_id?: string;
            name?: string;
            description?: string;
            active?: boolean;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateRefundInput: {
            amount?: number;
            adjustment_reason?: string;
            /** Format: uuid */
            parent_transaction_id: string;
            description?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        CreateRefundRequest: {
            refund: components["schemas"]["CreateRefundInput"];
        };
        UpdateRefundInput: {
            description?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        UpdateRefundRequest: {
            refund: components["schemas"]["UpdateRefundInput"];
        };
        Refund: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            account_id?: string;
            adjustment_reason?: string;
            amount?: number;
            currency?: string;
            /** Format: uuid */
            customer_id?: string;
            description?: string | null;
            metadata?: components["schemas"]["Metadata"];
            /** Format: uuid */
            original_transaction_id?: string;
            /** Format: uuid */
            parent_transaction_id?: string;
            /** Format: uuid */
            payment_intent_id?: string;
            /** Format: uuid */
            payment_method_id?: string;
            platform_fee?: number;
            source?: components["schemas"]["TransactionSourceType"];
            state?: components["schemas"]["RefundStateType"];
            statement_descriptor?: string;
            /** Format: date-time */
            succeeded_at?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
            /** @enum {string|null} */
            allowed_reverse_action?: "void" | null;
        };
        CreateRenderTemplateInput: {
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethodInput"][];
            billing_address_options: components["schemas"]["BillingAddressOptions"];
            currency?: string;
            origin_ids?: string[];
        };
        CreateRenderTemplateRequest: {
            render_template: components["schemas"]["CreateRenderTemplateInput"];
        };
        /** @description Replaces the origin allowlist on an existing render template. Currency, allowed payment methods, and billing address options are not updatable. */
        UpdateRenderTemplateInput: {
            /** @description Origin IDs in the current organization. Replaces the current list. At least one origin is required. */
            origin_ids: string[];
        };
        UpdateRenderTemplateRequest: {
            render_template: components["schemas"]["UpdateRenderTemplateInput"];
        };
        RenderTemplate: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            organization_id?: string;
            allowed_payment_methods?: components["schemas"]["AllowedPaymentMethod"][];
            billing_address_options: components["schemas"]["BillingAddressOptions"];
            currency?: string;
            /** Format: date-time */
            last_used_at?: string | null;
            origins: components["schemas"]["Origin"][];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateSetupIntentInput: {
            /**
             * Format: uuid
             * @description Customer on the authenticated organization.
             */
            customer_id?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        CreateSetupIntentRequest: {
            setup_intent: components["schemas"]["CreateSetupIntentInput"];
        };
        ConfirmSetupIntentWithPaymentMethodIdInput: {
            /** Format: uuid */
            payment_method_id: string;
        };
        ConfirmSetupIntentWithEmbeddedPaymentMethodInput: {
            payment_method: components["schemas"]["EmbedConfirmPaymentMethodInput"];
        };
        ConfirmSetupIntentWithPaymentMethodInput: components["schemas"]["ConfirmSetupIntentWithPaymentMethodIdInput"] | components["schemas"]["ConfirmSetupIntentWithEmbeddedPaymentMethodInput"];
        ConfirmSetupIntentWithPaymentMethodRequest: {
            setup_intent: components["schemas"]["ConfirmSetupIntentWithPaymentMethodInput"];
        };
        SetupIntent: {
            /** Format: uuid */
            id?: string;
            /**
             * Format: uuid
             * @description Organization that owns the setup intent.
             */
            organization_id?: string;
            /** Format: uuid */
            customer_id?: string;
            metadata?: components["schemas"]["Metadata"];
            /** Format: uuid */
            payment_method_id?: string;
            source?: components["schemas"]["TransactionSourceType"];
            /** @enum {string} */
            state?: "requires_payment_method" | "requires_confirmation" | "verifying" | "requires_review" | "succeeded" | "failed" | "cancelled" | "errored";
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateSubscriptionInput: {
            amount?: number;
            currency?: string;
            /** Format: uuid */
            customer_id?: string;
            cycles?: number;
            interval?: components["schemas"]["SubscriptionIntervalType"];
            interval_count?: number;
            /** Format: uuid */
            subscription_plan_id?: string;
        };
        CreateSubscriptionRequest: {
            subscription: components["schemas"]["CreateSubscriptionInput"];
        };
        UpdateSubscriptionInput: {
            /** Format: uuid */
            payment_method_id?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        UpdateSubscriptionRequest: {
            subscription: components["schemas"]["UpdateSubscriptionInput"];
        };
        SkipSubscriptionInput: {
            period_count?: number;
        };
        SkipSubscriptionRequest: {
            subscription: components["schemas"]["SkipSubscriptionInput"];
        };
        Subscription: {
            /** Format: uuid */
            id?: string;
            amount?: number;
            /** Format: date-time */
            cancel_at?: string | null;
            cancel_at_period_end?: boolean;
            /** Format: date-time */
            cancelled_at?: string | null;
            currency?: string;
            cycles?: number;
            /** Format: uuid */
            subscription_plan_id?: string;
            /** Format: uuid */
            customer_id?: string;
            /** Format: uuid */
            payment_method_id?: string;
            interval?: components["schemas"]["SubscriptionIntervalType"];
            interval_count?: number;
            metadata?: components["schemas"]["Metadata"];
            /** Format: date-time */
            start_at?: string | null;
            /** @enum {string} */
            state?: "active" | "paused" | "past_due" | "cancelled";
            cycles_completed?: number;
            skip_billing_periods_remaining?: number;
            skipped_billing_periods_count?: number;
            /** Format: date-time */
            current_billing_period_start?: string;
            /** Format: date-time */
            current_billing_period_end?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateSubscriptionPlanInput: {
            active?: boolean;
            amount?: number;
            currency?: string;
            cycles?: number;
            /** Format: uuid */
            product_id?: string;
            description?: string;
            interval?: components["schemas"]["SubscriptionIntervalType"];
            interval_count?: number;
            metadata?: components["schemas"]["Metadata"];
            name?: string;
            plan_type?: components["schemas"]["SubscriptionPlanType"];
            trial_period_days?: number;
        };
        CreateSubscriptionPlanRequest: {
            subscription_plan: components["schemas"]["CreateSubscriptionPlanInput"];
        };
        UpdateChargeInput: {
            description?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        UpdateChargeRequest: {
            charge: components["schemas"]["UpdateChargeInput"];
        };
        SubscriptionPlan: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            account_id?: string;
            /** Format: uuid */
            product_id?: string;
            active?: boolean;
            amount?: number;
            currency?: string;
            cycles?: number;
            description?: string;
            interval?: components["schemas"]["SubscriptionIntervalType"];
            interval_count?: number;
            metadata?: components["schemas"]["Metadata"];
            name?: string;
            plan_type?: components["schemas"]["SubscriptionPlanType"];
            trial_period_days?: number;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateVoidInput: {
            adjustment_reason?: string;
            /** Format: uuid */
            parent_transaction_id: string;
            description?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        CreateVoidRequest: {
            void: components["schemas"]["CreateVoidInput"];
        };
        UpdateVoidInput: {
            description?: string;
            metadata?: components["schemas"]["Metadata"];
        };
        UpdateVoidRequest: {
            void: components["schemas"]["UpdateVoidInput"];
        };
        Void: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            account_id?: string;
            adjustment_reason?: string;
            amount?: number;
            currency?: string;
            /** Format: uuid */
            customer_id?: string;
            description?: string | null;
            metadata?: components["schemas"]["Metadata"];
            /** Format: uuid */
            original_transaction_id?: string;
            /** Format: uuid */
            parent_transaction_id?: string;
            /** Format: uuid */
            payment_intent_id?: string;
            /** Format: uuid */
            payment_method_id?: string;
            platform_fee?: number;
            source?: components["schemas"]["TransactionSourceType"];
            state?: components["schemas"]["RefundStateType"];
            statement_descriptor?: string;
            /** Format: date-time */
            succeeded_at?: string;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        WebhookAttempt: {
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            webhook_request_id?: string;
            error_message?: string;
            response_body?: Record<string, never>;
            status_code?: number;
            success?: boolean;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        CreateWebhookEndpointInput: {
            events?: components["schemas"]["WebhookEventType"][];
            metadata?: components["schemas"]["Metadata"];
            active?: boolean;
            url?: string;
        };
        CreateWebhookEndpointRequest: {
            webhook_endpoint: components["schemas"]["CreateWebhookEndpointInput"];
        };
        WebhookEndpoint: {
            /** Format: uuid */
            id?: string;
            events?: components["schemas"]["WebhookEventType"][];
            metadata?: components["schemas"]["Metadata"];
            secret?: string;
            url?: string;
            active?: boolean;
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
        /** @description Body POSTed to a webhook endpoint for an event delivery. */
        WebhookEventPayload: {
            /**
             * Format: uuid
             * @description Stable event id for this delivery. Identical across retries of the same event; use for idempotent handling.
             */
            id: string;
            /**
             * Format: uuid
             * @description Id of the webhook endpoint that received this delivery.
             */
            webhook_id: string;
            event: components["schemas"]["WebhookEventType"];
            /** @description Event-specific payload keyed by resource descriptor. */
            data: {
                [key: string]: unknown;
            };
            metadata?: components["schemas"]["Metadata"];
        };
        WebhookRequest: {
            id?: string;
            /** Format: uuid */
            eventable_id?: string;
            eventable_type?: string;
            /** Format: uuid */
            organization_id?: string;
            /** Format: uuid */
            webhook_endpoint_id?: string;
            /** Format: date-time */
            expires_at?: string;
            request_body?: components["schemas"]["WebhookEventPayload"];
            /** Format: date-time */
            created_at?: string;
            /** Format: date-time */
            updated_at?: string;
        };
    };
    responses: never;
    parameters: {
        XIdempotencyHeader: string;
        /** @description Render template JWT required to create a payment or setup intent. */
        XRenderTokenHeader: string;
        /** @description The ID of the account to filter by */
        AccountIdQuery: string;
        /** @description The ID of the customer to filter by */
        CustomerIdQuery: string;
        /** @description Exact email match (case-insensitive). For substring search, use `q`. */
        EmailQuery: string;
        /** @description The external account ID to filter by */
        ExternalAccountIdQuery: string;
        /** @description The page of results to retrieve. */
        PageQuery: number;
        /** @description The ID of the original transaction to filter by */
        ParentTransactionIdQuery: string;
        /** @description The ID of the payment intent to filter by */
        PaymentIntentIdQuery: string;
        /** @description The ID of the customer to filter by. Mutually exclusive with payment_intent_id. */
        PaymentMethodCustomerIdQuery: string;
        /** @description The ID of the payment method to filter by */
        PaymentMethodIdQuery: string;
        /** @description The ID of the payment transaction to filter by */
        PaymentTransactionIdQuery: string;
        /** @description The payout direction to filter by */
        PayoutDirectionQuery: components["schemas"]["PayoutDirectionType"];
        /** @description The payout state to filter by */
        PayoutStateQuery: components["schemas"]["PayoutStateType"];
        /** @description Number of results per page. */
        PerPageQuery: number;
        /** @description Exact phone match (normalized to E.164 when possible). For substring search, use `q`. */
        PhoneQuery: string;
        /** @description Exact name match (case-insensitive). For substring search, use `q`. */
        NameQuery: string;
        /** @description Exact customer type match (e.g. RegisteredCustomer, GuestCustomer). */
        CustomerTypeQuery: string;
        /** @description Substring search across name, email, and phone (case-insensitive). */
        QQuery: string;
        /** @description Substring search across origin value (case-insensitive). */
        OriginQQuery: string;
        /** @description The ID of the webhook request to filter by */
        WebhookRequestIdQuery: string;
        /** @description The customer ID to filter by */
        OptionalCustomerIdQuery: string;
        DbaNameQuery: string;
        LegalEntityIdQuery: string;
        LegalNameQuery: string;
        /** @description Filter payment intents by id */
        PaymentIntentRecordIdQuery: string;
        ProcessorReferenceQuery: string;
        OriginalTransactionIdQuery: string;
        SubscriptionStateQuery: string;
        ExternalReferenceQuery: string;
        PaymentSnapshotStateQuery: string;
        WebhookEndpointIdQuery: string;
        WebhookEventQuery: string;
        EventableIdQuery: string;
        WebhookSuccessQuery: boolean;
    };
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    ListAccounts: {
        parameters: {
            query: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                merchant_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of accounts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Account"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    GetAccount: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single account */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Account"];
                };
            };
        };
    };
    UpdateAccount: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateAccountRequest"];
            };
        };
        responses: {
            /** @description A single account */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Account"];
                };
            };
        };
    };
    ListCharges: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The ID of the payment intent to filter by */
                payment_intent_id?: components["parameters"]["PaymentIntentIdQuery"];
                /** @description The customer ID to filter by */
                customer_id?: components["parameters"]["OptionalCustomerIdQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of charges */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Charge"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    GetCharge: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single charge */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Charge"];
                };
            };
        };
    };
    UpdateCharge: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateChargeRequest"];
            };
        };
        responses: {
            /** @description Charge updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Charge"];
                };
            };
        };
    };
    ListCustomers: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description Exact email match (case-insensitive). For substring search, use `q`. */
                email?: components["parameters"]["EmailQuery"];
                /** @description Exact phone match (normalized to E.164 when possible). For substring search, use `q`. */
                phone?: components["parameters"]["PhoneQuery"];
                /** @description Exact name match (case-insensitive). For substring search, use `q`. */
                name?: components["parameters"]["NameQuery"];
                /** @description Exact customer type match (e.g. RegisteredCustomer, GuestCustomer). */
                type?: components["parameters"]["CustomerTypeQuery"];
                /** @description Substring search across name, email, and phone (case-insensitive). */
                q?: components["parameters"]["QQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of customers */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Customer"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateCustomer: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateCustomerRequest"];
            };
        };
        responses: {
            /** @description Existing customer returned */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Customer"];
                };
            };
            /** @description Customer created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Customer"];
                };
            };
            /**
             * @description Email and phone match different customers, or the email is new and
             *     the phone already belongs to another customer.
             */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetCustomer: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single customer */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Customer"];
                };
            };
        };
    };
    UpdateCustomer: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateCustomerRequest"];
            };
        };
        responses: {
            /** @description Customer updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Customer"];
                };
            };
        };
    };
    GetDunningConfiguration: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The organization's dunning configuration */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DunningConfiguration"];
                };
            };
            /** @description Dunning configuration not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    CreateDunningConfiguration: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateDunningConfigurationRequest"];
            };
        };
        responses: {
            /** @description Dunning configuration created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DunningConfiguration"];
                };
            };
            /** @description Dunning configuration already exists */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    UpdateDunningConfiguration: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateDunningConfigurationRequest"];
            };
        };
        responses: {
            /** @description Dunning configuration updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DunningConfiguration"];
                };
            };
            /** @description Dunning configuration not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListExternalAccounts: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of external accounts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["ExternalAccount"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateExternalAccount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateExternalAccountRequest"];
            };
        };
        responses: {
            /** @description External account created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExternalAccount"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetExternalAccount: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single external account */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExternalAccount"];
                };
            };
        };
    };
    CreateFileUpload: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateFileUploadRequest"];
            };
        };
        responses: {
            /** @description File upload created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileUpload"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetFileUpload: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description File upload retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileDownload"];
                };
            };
        };
    };
    CompleteFileUpload: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description File upload completed successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FileDownload"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListLegalEntityApplicationDocuments: {
        parameters: {
            query: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                legal_entity_application_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of legal entity application documents */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["LegalEntityApplicationDocument"][];
                    };
                };
            };
        };
    };
    CreateLegalEntityApplicationDocument: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateLegalEntityApplicationDocumentRequest"];
            };
        };
        responses: {
            /** @description Legal entity application document created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplicationDocument"];
                };
            };
            /** @description Legal entity application not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Error creating legal entity application document */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListLegalEntities: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of legal entities */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["LegalEntity"][];
                        meta: Record<string, never>;
                    };
                };
            };
        };
    };
    GetLegalEntity: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Legal entity retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntity"];
                };
            };
        };
    };
    CreateLegalEntityApplication: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateLegalEntityApplicationRequest"];
            };
        };
        responses: {
            /** @description Legal entity application created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplication"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetLegalEntityApplication: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Legal entity application retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplication"];
                };
            };
        };
    };
    UpdateLegalEntityApplication: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateLegalEntityApplicationRequest"];
            };
        };
        responses: {
            /** @description Legal entity application updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplication"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    SubmitLegalEntityApplication: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Legal entity application submitted successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplication"];
                };
            };
            /** @description Legal entity application could not be submitted */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ApproveLegalEntityApplication: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Legal entity application approved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplication"];
                };
            };
            /** @description Legal entity application could not be approved */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    CreateLegalEntityApplicationPrincipal: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateLegalEntityApplicationPrincipalRequest"];
            };
        };
        responses: {
            /** @description Legal entity application principal created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplicationPrincipal"];
                };
            };
            /** @description Legal entity application not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Error creating legal entity application principal */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetLegalEntityApplicationPrincipal: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Legal entity application principal retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplicationPrincipal"];
                };
            };
        };
    };
    UpdateLegalEntityApplicationPrincipal: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateLegalEntityApplicationPrincipalRequest"];
            };
        };
        responses: {
            /** @description Legal entity application principal updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityApplicationPrincipal"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListLegalEntityPrincipals: {
        parameters: {
            query: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The ID of the legal_entity */
                legal_entity_id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of legal entity principals */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["LegalEntityPrincipal"][];
                        meta: Record<string, never>;
                    };
                };
            };
        };
    };
    GetLegalEntityPrincipal: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the legal entity principal to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of a legal entity principal */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegalEntityPrincipal"];
                };
            };
        };
    };
    CreateMerchantApplication: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateMerchantApplicationRequest"];
            };
        };
        responses: {
            /** @description Merchant application created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MerchantApplication"];
                };
            };
            /** @description Legal entity application not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Error creating merchant application */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetMerchantApplication: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the merchant application to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of a merchant application */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MerchantApplication"];
                };
            };
        };
    };
    UpdateMerchantApplication: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the merchant application to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateMerchantApplicationRequest"];
            };
        };
        responses: {
            /** @description Merchant application updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MerchantApplication"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListMerchants: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                dba_name?: components["parameters"]["DbaNameQuery"];
                legal_entity_id?: components["parameters"]["LegalEntityIdQuery"];
                legal_name?: components["parameters"]["LegalNameQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of merchants */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Merchant"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    GetMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the merchant to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of a merchant */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Merchant"];
                };
            };
        };
    };
    UpdateMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the merchant to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateMerchantRequest"];
            };
        };
        responses: {
            /** @description Merchant updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Merchant"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetOrganization: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The authenticated organization */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Organization"];
                };
            };
        };
    };
    UpdateOrganization: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateOrganizationRequest"];
            };
        };
        responses: {
            /** @description Organization updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Organization"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListOrigins: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description Substring search across origin value (case-insensitive). */
                q?: components["parameters"]["OriginQQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of origins */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Origin"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateOrigin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOriginRequest"];
            };
        };
        responses: {
            /** @description Origin created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Origin"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    DeleteOrigin: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the origin to delete */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Origin deleted successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Origin not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Origin is in use by a render template */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Apple Pay unregister failed; the origin was not deleted */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetEmbedPaymentIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment intent to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of payment intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentIntent"];
                };
            };
        };
    };
    ConfirmEmbedPaymentIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment intent to confirm */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfirmPaymentIntentWithPaymentMethodRequest"];
            };
        };
        responses: {
            /** @description Confirmation completed after the processor authorized, sold, or declined */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentIntent"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Unprocessable content */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListPaymentIntents: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description Filter payment intents by id */
                id?: components["parameters"]["PaymentIntentRecordIdQuery"];
                processor_reference?: components["parameters"]["ProcessorReferenceQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of payment intents */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["PaymentIntent"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreatePaymentIntent: {
        parameters: {
            query?: never;
            header: {
                /** @description Render template JWT required to create a payment or setup intent. */
                "X-Render-Token": components["parameters"]["XRenderTokenHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreatePaymentIntentRequest"];
            };
        };
        responses: {
            /** @description Successful creation of payment intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EmbedToken"];
                };
            };
            /** @description Unprocessable entity, including a missing X-Render-Token header. */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListPaymentLinks: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of payment links */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["PaymentLink"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreatePaymentLink: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreatePaymentLinkRequest"];
            };
        };
        responses: {
            /** @description Payment link created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentLink"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetPaymentLink: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment link to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Payment link retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentLink"];
                };
            };
            /** @description Payment link not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    UpdatePaymentLink: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment link to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdatePaymentLinkRequest"];
            };
        };
        responses: {
            /** @description Payment link updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentLink"];
                };
            };
            /** @description Payment link not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Error updating payment link */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetPaymentIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment intent to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of payment intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentIntent"];
                };
            };
        };
    };
    CancelPaymentIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment intent to cancel */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful cancellation of payment intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentIntent"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    CapturePaymentIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the payment intent to capture */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful capture of payment intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentIntent"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListPaymentMethods: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The ID of the customer to filter by. Mutually exclusive with payment_intent_id. */
                customer_id?: components["parameters"]["PaymentMethodCustomerIdQuery"];
                /** @description The ID of the payment intent to filter by */
                payment_intent_id?: components["parameters"]["PaymentIntentIdQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of payment methods */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["PaymentMethod"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreatePaymentMethod: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreatePaymentMethodRequest"];
            };
        };
        responses: {
            /** @description Payment method created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentMethod"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetPaymentMethod: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single payment method */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PaymentMethod"];
                };
            };
        };
    };
    ListPayouts: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The external account ID to filter by */
                external_account_id?: components["parameters"]["ExternalAccountIdQuery"];
                /** @description The payout direction to filter by */
                direction?: components["parameters"]["PayoutDirectionQuery"];
                /** @description The payout state to filter by */
                state?: components["parameters"]["PayoutStateQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of payouts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Payout"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreatePayout: {
        parameters: {
            query?: never;
            header?: {
                "X-Idempotency-Key"?: components["parameters"]["XIdempotencyHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreatePayoutRequest"];
            };
        };
        responses: {
            /** @description Payout created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Payout"];
                };
            };
            /** @description Error creating payout */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    BulkCreatePayouts: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateBulkPayoutsRequest"];
            };
        };
        responses: {
            /** @description Payouts created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data?: components["schemas"]["Payout"][];
                    };
                };
            };
            /** @description Error creating payouts */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Error creating payouts */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetPayout: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single payout */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Payout"];
                };
            };
        };
    };
    ListProcessorTransactions: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The ID of the payment intent to filter by */
                payment_intent_id?: components["parameters"]["PaymentIntentIdQuery"];
                /** @description The ID of the payment method to filter by */
                payment_method_id?: components["parameters"]["PaymentMethodIdQuery"];
                /** @description The ID of the payment transaction to filter by */
                payment_transaction_id?: components["parameters"]["PaymentTransactionIdQuery"];
                original_transaction_id?: components["parameters"]["OriginalTransactionIdQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of processor transactions */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["ProcessorTransaction"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    ListProducts: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of products */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Product"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateProduct: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProductRequest"];
            };
        };
        responses: {
            /** @description Product created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Product"];
                };
            };
            /** @description Error creating product */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    UpdateProduct: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the product to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateProductRequest"];
            };
        };
        responses: {
            /** @description Product updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Product"];
                };
            };
            /** @description Error updating product */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListRefunds: {
        parameters: {
            query: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The ID of the customer to filter by */
                customer_id: components["parameters"]["CustomerIdQuery"];
                /** @description The ID of the original transaction to filter by */
                parent_transaction_id?: components["parameters"]["ParentTransactionIdQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of refunds */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Refund"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateRefund: {
        parameters: {
            query?: never;
            header?: {
                "X-Idempotency-Key"?: components["parameters"]["XIdempotencyHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateRefundRequest"];
            };
        };
        responses: {
            /** @description Refund created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Refund"];
                };
            };
            /** @description Error creating refund */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetRefund: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the refund to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of refund */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Refund"];
                };
            };
        };
    };
    UpdateRefund: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the refund to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateRefundRequest"];
            };
        };
        responses: {
            /** @description Refund updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Refund"];
                };
            };
        };
    };
    CancelRefund: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the refund to cancel. */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Refund cancelled successfully */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Refund"];
                };
            };
        };
    };
    ListRenderTemplates: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                account_id?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of render templates */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["RenderTemplate"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateRenderTemplate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateRenderTemplateRequest"];
            };
        };
        responses: {
            /** @description Render template created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RenderTemplate"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetRenderTemplate: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single render template */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RenderTemplate"];
                };
            };
        };
    };
    UpdateRenderTemplate: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the render template to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateRenderTemplateRequest"];
            };
        };
        responses: {
            /** @description Render template updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RenderTemplate"];
                };
            };
            /** @description Render template not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    CreateRenderToken: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A render token for the render template */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RenderToken"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetSetupIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the setup intent to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of setup intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetupIntent"];
                };
            };
        };
    };
    ConfirmEmbedSetupIntent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the setup intent to confirm */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfirmSetupIntentWithPaymentMethodRequest"];
            };
        };
        responses: {
            /** @description Confirmation completed after verification succeeded or failed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetupIntent"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
            /** @description Unprocessable content */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    CreateSetupIntent: {
        parameters: {
            query?: never;
            header: {
                /** @description Render template JWT required to create a payment or setup intent. */
                "X-Render-Token": components["parameters"]["XRenderTokenHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateSetupIntentRequest"];
            };
        };
        responses: {
            /** @description Successful creation of setup intent */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["EmbedToken"];
                };
            };
            /** @description Unprocessable entity, including a missing X-Render-Token header. */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    ListSubscriptionPlans: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description Exact name match (case-insensitive). For substring search, use `q`. */
                name?: components["parameters"]["NameQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of subscription plans */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["SubscriptionPlan"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateSubscriptionPlan: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateSubscriptionPlanRequest"];
            };
        };
        responses: {
            /** @description Subscription plan created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SubscriptionPlan"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetSubscriptionPlan: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the subscription plan to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of subscription plan */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SubscriptionPlan"];
                };
            };
        };
    };
    ListSubscriptions: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                state?: components["parameters"]["SubscriptionStateQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of subscriptions */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Subscription"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateSubscription: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateSubscriptionRequest"];
            };
        };
        responses: {
            /** @description Subscription created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Subscription"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetSubscription: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the subscription to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of subscription */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Subscription"];
                };
            };
        };
    };
    UpdateSubscription: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the subscription to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateSubscriptionRequest"];
            };
        };
        responses: {
            /** @description Subscription updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Subscription"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    SkipSubscription: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the subscription to skip billing periods for */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SkipSubscriptionRequest"];
            };
        };
        responses: {
            /** @description Subscription billing periods skipped successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Subscription"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    CancelSubscription: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the subscription to cancel */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful cancellation of subscription */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Subscription"];
                };
            };
        };
    };
    ListVoids: {
        parameters: {
            query: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                /** @description The ID of the customer to filter by */
                customer_id: components["parameters"]["CustomerIdQuery"];
                /** @description The ID of the original transaction to filter by */
                parent_transaction_id?: components["parameters"]["ParentTransactionIdQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of voids */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["Void"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateVoid: {
        parameters: {
            query?: never;
            header?: {
                "X-Idempotency-Key"?: components["parameters"]["XIdempotencyHeader"];
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateVoidRequest"];
            };
        };
        responses: {
            /** @description Void created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Void"];
                };
            };
            /** @description Error creating void */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetVoid: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the void to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful retrieval of void */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Void"];
                };
            };
        };
    };
    UpdateVoid: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the void to update */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateVoidRequest"];
            };
        };
        responses: {
            /** @description Void updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Void"];
                };
            };
        };
    };
    ListWebhookAttempts: {
        parameters: {
            query: {
                /** @description The ID of the webhook request to filter by */
                webhook_request_id: components["parameters"]["WebhookRequestIdQuery"];
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of webhook attempts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["WebhookAttempt"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    ListWebhookEndpoints: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of webhook endpoints */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["WebhookEndpoint"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    CreateWebhookEndpoint: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateWebhookEndpointRequest"];
            };
        };
        responses: {
            /** @description Webhook endpoint created successfully */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WebhookEndpoint"];
                };
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    GetWebhookEndpoint: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A single webhook endpoint */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WebhookEndpoint"];
                };
            };
        };
    };
    UpdateWebhookEndpoint: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateWebhookEndpointRequest"];
            };
        };
        responses: {
            /** @description Webhook endpoint updated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WebhookEndpoint"];
                };
            };
        };
    };
    DeleteWebhookEndpoint: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Webhook endpoint deleted successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ListWebhookRequests: {
        parameters: {
            query?: {
                /** @description The page of results to retrieve. */
                page?: components["parameters"]["PageQuery"];
                /** @description Number of results per page. */
                per_page?: components["parameters"]["PerPageQuery"];
                webhook_endpoint_id?: components["parameters"]["WebhookEndpointIdQuery"];
                success?: components["parameters"]["WebhookSuccessQuery"];
                event?: components["parameters"]["WebhookEventQuery"];
                eventable_id?: components["parameters"]["EventableIdQuery"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description A list of webhook requests */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        data: components["schemas"]["WebhookRequest"][];
                        meta: components["schemas"]["Meta"];
                    };
                };
            };
        };
    };
    ResendWebhookRequest: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the webhook request to resend */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Accepted; webhook resend has been enqueued */
            202: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unprocessable entity */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Error"];
                };
            };
        };
    };
    RetrieveWebhookRequest: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The ID of the webhook request to retrieve */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Webhook request retrieved successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["WebhookRequest"];
                };
            };
        };
    };
}
type FlattenedDeepRequired<T> = {
    [K in keyof T]-?: FlattenedDeepRequired<T[K] extends unknown[] | undefined | null ? Extract<T[K], unknown[]>[number] : T[K]>;
};
type ReadonlyArray<T> = [
    Exclude<T, undefined>
] extends [
    unknown[]
] ? Readonly<Exclude<T, undefined>> : Readonly<Exclude<T, undefined>[]>;
export const bankAccountProfileFailure_reasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["BankAccountProfile"]["failure_reason"]> = ["activation_failed", "processing_error", "vault_failed", "insufficient_funds", "verification_failed"];
export const cardProfileFailure_reasonValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["CardProfile"]["failure_reason"]> = ["authorization_failed", "avs_blocked", "brand_not_allowed", "brand_not_found", "cvc_blocked", "processing_error", "vault_failed"];
export const chargeAllowed_reverse_actionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Charge"]["allowed_reverse_action"]> = ["void", "refund"];
export const chargeStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Charge"]["state"]> = ["cancelled", "errored", "failed", "processing", "requires_capture", "requires_confirmation", "requires_review", "settlement_failed", "succeeded"];
export const externalAccountTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ExternalAccount"]["type"]> = ["external_card", "external_bank_account"];
export const legalEntityEntityTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LegalEntityEntityType"]> = ["individual_sole_proprietorship", "corporation", "limited_liability_company", "partnership", "limited_partnership", "general_partnership", "tax_exempt_organization", "government_agency"];
export const legalEntityOwnershipTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LegalEntityOwnershipType"]> = ["public", "private"];
export const legalEntityDocumentTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["LegalEntityDocumentType"]> = ["irs_cp_575"];
export const merchantBusinessCategoryTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["MerchantBusinessCategoryType"]> = ["business_association", "charity", "church", "county", "federal", "fraternal_org", "government", "higher_education", "k12", "labor_union", "local", "ministry", "pac", "parachurch", "party", "preschool", "social_club", "social_welfare", "state", "tribal", "vendor", "veterans_org"];
export const paymentIntentCaptureMethodTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PaymentIntentCaptureMethodType"]> = ["automatic", "automatic_async", "manual"];
export const paymentLinkAmountTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PaymentLinkAmountType"]> = ["fixed", "open"];
export const paymentMethodTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PaymentMethodType"]> = ["card", "bank_account", "googlepay", "applepay"];
export const usStateTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UsStateType"]> = ["AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"];
export const usOnlyBillingAddressOptionsModeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["UsOnlyBillingAddressOptions"]["mode"]> = ["us_only"];
export const internationalBillingAddressOptionsModeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["InternationalBillingAddressOptions"]["mode"]> = ["international"];
export const embedConfirmCardPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EmbedConfirmCardPaymentMethodInput"]["type"]> = ["card"];
export const embedConfirmBankAccountPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EmbedConfirmBankAccountPaymentMethodInput"]["type"]> = ["bank_account"];
export const embedConfirmGooglePayPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EmbedConfirmGooglePayPaymentMethodInput"]["type"]> = ["googlepay"];
export const embedConfirmApplePayPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["EmbedConfirmApplePayPaymentMethodInput"]["type"]> = ["applepay"];
export const allowedCardPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedCardPaymentMethodInput"]["type"]> = ["card"];
export const allowedBankAccountPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedBankAccountPaymentMethodInput"]["type"]> = ["bank_account"];
export const allowedGooglePayPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedGooglePayPaymentMethodInput"]["type"]> = ["googlepay"];
export const allowedApplePayPaymentMethodInputTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedApplePayPaymentMethodInput"]["type"]> = ["applepay"];
export const allowedCardPaymentMethodTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedCardPaymentMethod"]["type"]> = ["card"];
export const allowedBankAccountPaymentMethodTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedBankAccountPaymentMethod"]["type"]> = ["bank_account"];
export const allowedGooglePayPaymentMethodTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedGooglePayPaymentMethod"]["type"]> = ["googlepay"];
export const allowedApplePayPaymentMethodTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["AllowedApplePayPaymentMethod"]["type"]> = ["applepay"];
export const payoutDirectionTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PayoutDirectionType"]> = ["credit", "debit"];
export const payoutStateTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PayoutStateType"]> = ["pending", "processing", "succeeded", "failed", "errored", "accepted", "rejected"];
export const refundStateTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["RefundStateType"]> = ["pending", "processing", "requires_review", "succeeded", "cancelled", "failed"];
export const subscriptionIntervalTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SubscriptionIntervalType"]> = ["day", "week", "month", "year"];
export const subscriptionPlanTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SubscriptionPlanType"]> = ["fixed", "variable"];
export const transactionSourceTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["TransactionSourceType"]> = ["api", "dashboard", "iframe", "system", "subscription", "admin"];
export const walletProviderTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WalletProviderType"]> = ["googlepay", "applepay"];
export const webhookEventTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["WebhookEventType"]> = ["charge.cancelled", "charge.created", "charge.errored", "charge.failed", "charge.processing", "charge.requires_capture", "charge.requires_confirmation", "charge.requires_review", "charge.settlement_failed", "charge.succeeded", "customer.created", "customer.updated", "legal_entity.created", "legal_entity.updated", "legal_entity_principal.created", "legal_entity_principal.updated", "legal_entity_application.approved", "legal_entity_application.denied", "legal_entity_application.needs_information", "legal_entity_application.pending", "legal_entity_application.submitted", "merchant.created", "merchant.updated", "payment_intent.cancelled", "payment_intent.created", "payment_intent.errored_authorization", "payment_intent.errored_capture", "payment_intent.errored_sale", "payment_intent.processing_authorization", "payment_intent.processing_capture", "payment_intent.processing_sale", "payment_intent.requires_capture", "payment_intent.requires_confirmation", "payment_intent.requires_payment_method", "payment_intent.requires_review", "payment_intent.succeeded", "processor_transaction.completed", "reconciliation.created", "refund.cancelled", "refund.created", "refund.failed", "refund.pending", "refund.processing", "refund.requires_review", "refund.succeeded", "setup_intent.cancelled", "setup_intent.created", "setup_intent.errored", "setup_intent.failed", "setup_intent.requires_confirmation", "setup_intent.requires_payment_method", "setup_intent.requires_review", "setup_intent.succeeded", "setup_intent.verifying", "void.created", "void.failed", "void.pending", "void.processing", "void.requires_review", "void.succeeded"];
export const organizationKindValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Organization"]["kind"]> = ["direct", "payfac"];
export const originApplepayRegistrationStateTypeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["OriginApplepayRegistrationStateType"]> = ["pending", "skipped", "registered", "failed"];
export const paymentIntentStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["PaymentIntent"]["state"]> = ["requires_payment_method", "requires_confirmation", "requires_capture", "processing_authorization", "processing_capture", "processing_sale", "requires_review", "succeeded", "cancelled", "errored_authorization", "errored_capture", "errored_sale"];
export const processorTransactionPayment_transaction_typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ProcessorTransaction"]["payment_transaction_type"]> = ["charge", "refund", "void"];
export const processorTransactionTransaction_typeValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["ProcessorTransaction"]["transaction_type"]> = ["authorization", "authorization_reversal", "capture", "credit", "echeck_credit", "echeck_sale", "echeck_void", "sale", "void"];
export const refundAllowed_reverse_actionValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Refund"]["allowed_reverse_action"]> = ["void"];
export const setupIntentStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["SetupIntent"]["state"]> = ["requires_payment_method", "requires_confirmation", "verifying", "requires_review", "succeeded", "failed", "cancelled", "errored"];
export const subscriptionStateValues: ReadonlyArray<FlattenedDeepRequired<components>["schemas"]["Subscription"]["state"]> = ["active", "paused", "past_due", "cancelled"];
